import { initializeAppCheck, ReCaptchaV3Provider, onTokenChanged } from 'firebase/app-check'

export const initializeRNAppCheck = app => {
	self.FIREBASE_APPCHECK_DEBUG_TOKEN = process.env.FIREBASE_DEBUG_TOKEN_WEB
	initializeAppCheck(app, {
		provider: new ReCaptchaV3Provider(process.env.FIREBASE_RECAPTCHA_SITE_KEY),
		isTokenAutoRefreshEnabled: true,
	})
}
